export { useConsents } from './useConsents';



// WEBPACK FOOTER //
// ./src/components/Consents/hooks/index.js